export const normalizeString = (str: string) => str.toLowerCase().replace(/\s+/g, ' ').trim();
